if (!customElements.get("tab-component")) {
  class TabComponent extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", this.main.bind(this));
    }
    connectedCallback() {
      this.sectionReference = document.getElementById(this.dataset.sectionId);
    }
    main() {
      if (this.hasAttribute('disabled')) return;
      this.closeTab();
      this.openTab();
    }
    openTab() {
      if (!this.sectionReference) return;
      this.classList.add("active");
      this.sectionReference.querySelectorAll(`#${this.dataset.openTab}`).forEach(tab => {
        tab.classList.add("active");
      });
      this.sectionReference.querySelectorAll(`[data-open-tab=${this.dataset.openTab}]`).forEach(tab => {
        tab.classList.add("active");
        if (tab.dataset.step) {
          const stepValue = this.dataset.step;
          const urlParams = new URLSearchParams(window.location.search);
          urlParams.set('step', stepValue);
          window.history.replaceState({}, '', window.location.pathname + '?' + urlParams.toString());
        }
      });
    }
    closeTab() {
      if (!this.sectionReference) return;
      this.sectionReference.querySelectorAll("tab-component.active").forEach(tab => {
        tab.classList.remove("active");
      });
      this.sectionReference.querySelectorAll(".tab__content.active").forEach(tab => {
        tab.classList.remove("active");
      });
    }
  }
  customElements.define("tab-component", TabComponent);
}